import { defineStore } from 'pinia'

const STORAGE_KEY = 'geofusion-theme'

function preferredTheme() {
  const saved = window.localStorage.getItem(STORAGE_KEY)
  if (saved === 'light' || saved === 'dark') return saved
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

export const useThemeStore = defineStore('theme', {
  state: () => ({
    theme: preferredTheme()
  }),
  actions: {
    apply() {
      document.documentElement.dataset.theme = this.theme
      document.documentElement.style.colorScheme = this.theme
    },
    toggle() {
      this.theme = this.theme === 'dark' ? 'light' : 'dark'
      window.localStorage.setItem(STORAGE_KEY, this.theme)
      this.apply()
    }
  }
})
